<!-- 本社介绍跳转，单独的新闻详情页 -->
<template>
  <div id="introduce">
    <headerVue></headerVue>
    <div class="container">
      <!-- 左侧 -->
      <el-col :span="5" class="left">
        <!-- 首页的导航栏 -->
        <h3>{{ this.$route.query.name }}</h3>
        <el-menu background-color="#fff" unique-opened :default-active="activeIndex" @select="toItemList"
          class="parent-menu">
          <template v-for="(item, index) in navList">
            <template v-if="item.children && item.children.length > 0">
              <el-submenu :index="item.id" :key="item.id">
                <template slot="title">
                  <span slot="title">{{ item.navName }}</span>
                </template>
                <el-menu-item class="children-item" v-for="subItem in item.children" :index="subItem.id"
                  :key="subItem.id">
                  <span slot="title">{{ subItem.navName }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="item.id" :key="item.id + index" class="parent-item">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.navName }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-col>
      <!-- 移动端的小导航条 -->
      <div class="citylist">
        <div class="citybox" :style="{ width: 100 / navList.length + '%' }" :class="{ active: currentNav == item.id }"
          v-for="(item, index) in navList" @click="toItemList(item.id)" :index="index.toString()" :key="item.id">
          {{ item.navName }}
        </div>
      </div>
      <!-- 右侧 -->
      <el-col :span="19" style="float: right" class="right">
        <template v-if="imgList.length">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ imgList[0].jsNavName }}</h3>
          <div class="liji_content" style="width: 100%;display: flex;flex-wrap: wrap;">
            <div class="" v-for="item in imgList" :key="item.id" style="
                width: 120px;
                height: 180px;
                margin: 0 6px 10px 0;
                text-align: center;
              ">
              <!-- {{ item }} -->
              <img @click="toDetailWei(item.id)" style="width: 120px; height: 150px"
                :src="item.articleImg.startsWith('/profile') ? `http://www.shx93.gov.cn/prod-api${item.articleImg}` : `http://www.shx93.gov.cn/prod-api/profile/${item.articleImg}`"
                alt="" srcset="" />
              {{ item.title }}
            </div>
          </div>
        </template>
        <!-- 只有一条就显示文章详情 -->
        <div v-else-if="isList.length <= 1" class="introduce_right">
          <!-- <div class="introduce_right"> -->
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ articleInfo.title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <!-- 组织结构 -->
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(this.articleInfo.articleContent)"></div>
          </div>
        </div>
        <!-- isList 是组织结构 -->
        <!-- 组织结构的情况 -->
        <div v-else-if="isList && isList[14] && (isList[14].jsNavName == '组织结构') &&
          click_kjwyh == false &&
          click_jjwyh == false &&
          click_nlwyh == false &&
          click_jywhwyh == false &&
          click_flwyh == false &&
          click_shjswyh == false &&
          click_yywswyh == false &&
          click_zyhjwyh == false &&
          click_fnwyh == false &&
          click_qngzwyh == false &&
          click_llyssyjzx == false &&
          click_sxjsbwh == false &&
          click_sxjsxstzhyjy == false &&
          click_sxjsxsxczxyjy == false
        ">
          <!-- <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[1].title }}</h3> -->
          <!-- <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div> -->
          <div class="imageCover">
            <p @click="click_kjwyh = true"></p>
            <p @click="click_jjwyh = true"></p>
            <p @click="click_nlwyh = true"></p>
            <p @click="click_jywhwyh = true"></p>
            <p @click="click_flwyh = true"></p>
            <p @click="click_shjswyh = true"></p>
            <p @click="click_yywswyh = true"></p>
            <p @click="click_zyhjwyh = true"></p>
            <p @click="click_fnwyh = true"></p>
            <p @click="click_qngzwyh = true"></p>
            <p @click="click_llyssyjzx = true"></p>
            <p @click="click_sxjsbwh = true"></p>
            <p @click="click_sxjsxstzhyjy = true"></p>
            <p @click="click_sxjsxsxczxyjy = true"></p>
          </div>
        </div>
        <!-- 组织结构-科技委员会跳转 -->
        <div v-else-if="click_kjwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[13].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[13].articleContent)"></div>
          </div>
        </div>
        <!-- 经济委员会跳转 -->
        <div v-else-if="click_jjwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[12].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[12].articleContent)"></div>
          </div>
        </div>
        <!-- 农林委员会跳转 -->
        <div v-else-if="click_nlwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[11].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[11].articleContent)"></div>
          </div>
        </div>
        <!-- 教育文化委员会跳转 -->
        <div v-else-if="click_jywhwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[10].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[10].articleContent)"></div>
          </div>
        </div>
        <!-- 法律委员会跳转 -->
        <div v-else-if="click_flwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[9].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[9].articleContent)"></div>
          </div>
        </div>
        <!-- 社会建设委员会跳转 -->
        <div v-else-if="click_shjswyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[8].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[8].articleContent)"></div>
          </div>
        </div>
        <!-- 医药卫生委员会跳转 -->
        <div v-else-if="click_yywswyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[7].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[7].articleContent)"></div>
          </div>
        </div>
        <!-- 资源环境委员会跳转 -->
        <div v-else-if="click_zyhjwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[6].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[6].articleContent)"></div>
          </div>
        </div>
        <!-- 妇女委员会跳转 -->
        <div v-else-if="click_fnwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[5].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[5].articleContent)"></div>
          </div>
        </div>
        <!-- 青年工作委员会跳转 -->
        <div v-else-if="click_qngzwyh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[4].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[4].articleContent)"></div>
          </div>
        </div>
        <!-- 理论与社史委员会跳转 -->
        <div v-else-if="click_llyssyjzx">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[3].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[3].articleContent)"></div>
          </div>
        </div>
        <!-- 《陕西九三》编委会会跳转 -->
        <div v-else-if="click_sxjsbwh">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[2].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[2].articleContent)"></div>
          </div>
        </div>
        <!-- 陕西九三学社“碳中和”研究院跳转 -->
        <div v-else-if="click_sxjsxstzhyjy">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[1].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[1].articleContent)"></div>
          </div>
        </div>
        <!-- 陕西九三学社乡村振兴研究院跳转 -->
        <div v-else-if="click_sxjsxsxczxyjy">
          <h3 style="width:100%;margin:20px auto;text-align: center;">{{ isList[0].title }}</h3>
          <div style="width:100%;height: 2px; background: rgb(28, 116, 205); margin-bottom: 10px"></div>
          <div class="introduce_content content" alt="aaaa"
            style="padding: 20px 30px 0px 30px;border: 1px solid #f5f5f5;">
            <!-- <p v-html="this.articleInfo.articleContent"></p> -->
            <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
              v-html="$options.filters.safeHtmlContent(isList[0].articleContent)"></div>
          </div>
        </div>
        <!-- -------------------------------------------------------- -->
        <!-- 否则就显示文章列表 -->
        <div class="right" v-else>
          <div class="content" v-for="item in newsList" :key="item.id">
            <img class="icon" src="../../assets/image/picture/icon_local1.png" />
            <div class="title" @click="toDetails(item.id)">
              {{ item.title }}
            </div>
            <span>{{ item.releaseTime }}</span>
          </div>
        </div>
      </el-col>
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// Vue.filter('formatter', function (value) {
//   // 只给 p 标签加首行缩进的样式
//   return value.replace(/<p>/g, '<p style="text-indent: 20px;">');
// });

export default {
  name: "introduce",
  data() {
    return {
      isList: [],
      currentNav: "",
      navList: [],
      newsList: [],
      articleInfo: {
        title: "",
        articleContent: "",
      },
      total: 0,
      // 分页
      pageData: {
        // 一页几条
        pageSize: 10,
        // 当前页数
        currentPage: 1,
      },
      query: {
        // 当前页数
        currentPage: 1,
        // 一页几条
        pageSize: 10,
      },
      fontSize: "18px",
      activeIndex: '',
      menuslist: [],
      imgList: [],

      click_kjwyh: false,
      click_jjwyh: false,
      click_nlwyh: false,
      click_jywhwyh: false,
      click_flwyh: false,
      click_shjswyh: false,
      click_yywswyh: false,
      click_zyhjwyh: false,
      click_fnwyh: false,
      click_qngzwyh: false,
      click_llyssyjzx: false,
      click_sxjsbwh: false,
      click_sxjsxstzhyjy: false,
      click_sxjsxsxczxyjy: false,
    }
  },
  created() {
    this.getNavList();
    // this.toItemList(this.$route.query.show);
    this.fontSizeChange()
  },
  filters: {
    safeHtmlContent(val) {
      // return val.replace(/<p>/g, '<p style="text-indent: 30px; !importent">');
      return val.replace(/<p>/g, '<p style="text-indent: 2em;text-align:justify;font-size: 16px;">');
    }
  },
  // computed: {
  //   safeHtmlContent() {
  //     // 在这里应用过滤器
  //     return this.$options.filters.formatter(this.articleInfo.articleContent);
  //   }
  // },
  mounted() {

  },
  watch: {
    $route(to, from) {
      this.fontSizeChange();
      this.getNavList();
    },
  },
  beforeMounted() {
    // 处理 v-html 解析富文本中有图片的情况
    // let DomList = document
    //   .getElementsByClassName("content")[0]
    //   .querySelectorAll("img");
    // // console.log(DomList);
    // for (let i in DomList) {
    //   if (DomList[i].style) {
    //     console.log(DomList[i].src);
    //     if (DomList[i].src.indexOf("/prod-api/profile") != -1) {
    //     } else {
    //       DomList[i].src =
    //         DomList[i].src.substr(0, 33) +
    //         "prod-api/profile/" +
    //         DomList[i].src.substr(33);
    //     }
    //     console.log(DomList[i].src);
    //     DomList[i].style.width = "100%";
    //   }
    // }
  },
  methods: {
    initImage() {
      // console.log('mymap', $('.mymap'), maphilight);
      // $(this.$refs.mymaps).maphilight();
      // $('.mymap').maphilight();
      // $('.map').maphilight();
    },
    // -------  替换图片链接 --------start
    replaceImg(a) {
      // a 为富文本的字符串内容，为了测试，只写了img标签
      var b = /< img [^>]*src=['"]([^'"]+)[^>]*>/g; // img 标签取src里面内容的正则
      var s = a.match(b); // 取到所有img标签 放到数组 s里面
      if (s) {
        for (var i = 0; i < s.length; i++) {
          var srcImg = s[i].replace(b, '$1'); //取src面的内容
          // 这里用来拼接
          var baseUrl = '/prod-api/profile';
          if (srcImg != '' && srcImg != undefined) {
            if (srcImg.startsWith('/prod-api/profile')) {
              // console.log('富文本图片路径以/prod-api/profile开头');

            } else {
              // console.log('富文本图片路径不以/prod-api/profile开头');
              //修改富文本字符串内容 img标签src 相对路径改为绝对路径
              a = a.replace(/src=['"]([^'"]+)[^>]*>/gi, 'src="' + baseUrl + srcImg + '"' + '>');
              // console.log(srcImg);
            }
          }
        }
      }
      return a
    },
    toDetailWei(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`);
    },
    // 只有专题专栏字号是15px，其他的是18px
    fontSizeChange() {
      if (this.$route.query.title === '专题专栏') {
        this.fontSize = "15px"
      } else {
        this.fontSize = "18px"
      }
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 获取侧边的菜单栏列表
    async getNavList() {
      let res = await this.$api.nav.getNavList(1, this.$route.query.tm);
      this.navList = res.data.data;
      const arr = this.navList.filter(item => item.id === this.$route.query.childId);
      if (!this.$route.query.childId) {
        this.toItemList(res.data.data[0].id)
        this.activeIndex = res.data.data[0].id;
        return;
      }
      if (arr.length) {
        if (arr[0].children.length) {
          this.toItemList(arr[0].children[0].id)
          this.activeIndex = arr[0].children[0].id;
        } else {
          this.toItemList(this.$route.query.childId)
          this.activeIndex = this.$route.query.childId;
        }
      }
      // this.activeIndex = '1139884920877875200'
    },
    // 点击菜单项
    async toItemList(_id) {
      this.click_kjwyh = false
      this.click_kjwyh = false
      this.click_jjwyh = false
      this.click_nlwyh = false
      this.click_jywhwyh = false
      this.click_flwyh = false
      this.click_shjswyh = false
      this.click_yywswyh = false
      this.click_zyhjwyh = false
      this.click_fnwyh = false
      this.click_qngzwyh = false
      this.click_llyssyjzx = false
      this.click_sxjsbwh = false
      this.click_sxjsxstzhyjy = false
      this.click_sxjsxsxczxyjy = false

      // console.log('1111111111111',navName);
      // console.log('aaaaaaaa',this.navList);
      this.currentNav = _id;
      console.log("_id", _id);
      if (["1182327992215404544", '1182328032661078016', "1182328063694733312"].includes(_id)) {
        let res = await this.$api.nav.getWeiImgLists(_id);
        this.imgList = res.data.rows;
        return
      }
      // 点击组织结构跳转
      // if( _id == '1182327143221166080'){
      //   this.$router.push(`/Zzjg?tm=${_id}`);
      // }
      this.imgList = [];
      let res = await this.$api.nav.getArticle(_id, 1, 20);
      console.log('res', res);
      this.isList = res.data.rows;

      // this.$nextTick(() => {
      //   this.initImage();
      // })
      console.log("详情----------", res.data.rows.length);
      if (res.data.rows.length) {
        // 文章数大于1的情况
        if (res.data.rows.length && res.data.rows.length > 1) {
          console.log('很多条');
          this.newsList = res.data.rows;
          // console.log('newListttt', this.newsList);
          this.total = res.data.total
          // this.newsList.map(item => {
          //   if (item.id == '1189239897160941568') {
          //     this.articleInfo.title = item.title;
          //     this.articleInfo.articleContent = item.articleContent;
          //   }
          // })
        } else {
          // 文章数只有1条的情况
          this.articleInfo.title = res.data.rows[0].title;
          this.articleInfo.articleContent = res.data.rows[0].articleContent;
          // ------- 处理富文本图片信息 start
          const replacedArticleContent = this.replaceImg(this.articleInfo.articleContent)

          // console.log('---替换图片后内容');
          // console.log(replacedArticleContent);
          this.articleInfo.articleContent = replacedArticleContent;
          //------- 处理富文本图片信息 end
        }
      }
    },
    // 新闻列表跳转至新闻详情
    toDetails(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`);
      // this.$router.push({ name: "routeNewsDetail", params: { id: _id } });
    },
  },
  components: {
    headerVue,
    footerVue,
  },
}
</script>

<style lang="scss" scoped>
.ql-lineheight-5 {
  line-height: 5;
}

ql-lineheight-1-5 {
  line-height: 1.5;
}

ql-lineheight-1-75 {
  line-height: 1.75;
}

ql-lineheight-2 {
  line-height: 2;
}

ql-lineheight-3 {
  line-height: 3;
}

ql-lineheight-4 {
  line-height: 4;
}

ql-lineheight-5 {
  line-height: 5;
}

#newsList {
  background-color: #f5f5f5;
}

.container {
  background-color: white;
  margin-top: 0px;
  // min-height: 6000px;
  max-width: 1200px;

  .el-col-5 {
    width: 18%;
    margin-left: 5px;
    border: 1px solid #1c74cd;
    // padding: 0 20px 30px;
    box-sizing: border-box;
  }

  .el-col-5 h3 {
    background-color: #1c74cd;
    color: white;
    padding: 20px;
    text-align: center;
    font-weight: lighter;
    font-size: 22px;
  }

  .el-menu-item {
    font-size: 15px;
    height: 80px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
  }

  .imageCover {
    // width: 100%;
    // padding: 20px;
    margin-top: 50px;
    margin-left: 20px;
    height: 513px;
    width: 950px;
    background-size: 100% 100%;
    background-image: url('../../assets/image/zuzhijiegou.png');
    position: relative;

    >p {
      height: 210px;
      width: 35px;
      // border: 1px solid black;
      box-sizing: border-box;
      position: absolute;
      top: 242px;

      &:hover {
        cursor: pointer;
      }
    }

    >p:nth-of-type(1) {
      left: 329px;
    }

    >p:nth-of-type(2) {
      left: 366px;
    }

    >p:nth-of-type(3) {
      left: 403px;
    }

    >p:nth-of-type(4) {
      left: 440px;
    }

    >p:nth-of-type(5) {
      left: 477px;
    }

    >p:nth-of-type(6) {
      left: 516px;
    }

    >p:nth-of-type(7) {
      left: 554px;
    }

    >p:nth-of-type(8) {
      left: 591px;
    }

    >p:nth-of-type(9) {
      left: 629px;
    }

    >p:nth-of-type(10) {
      left: 679px;
    }

    >p:nth-of-type(11) {
      left: 734px;
    }

    >p:nth-of-type(12) {
      left: 773px;
    }

    >p:nth-of-type(13) {
      height: 265px;
      left: 810px;
    }

    >p:nth-of-type(14) {
      height: 265px;
      left: 847px;
    }
  }

  .el-menu-item:hover {
    background-color: #ECF5FF;
    color: #409EFF;
    // font-weight: 600;
  }

  .right {

    // margin-left: 30px;
    // width: 100%;
    // height: 570px;
    // border: 1px solid #f5f5f5;
    // overflow-y: scroll;
    .content {
      display: flex;
      align-items: center;
      padding: 17px;
      border-bottom: 1px solid #f0f0f0;
      position: relative;
      background-color: white;

      img {
        margin-right: 10px;
      }

      .title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      span {
        position: absolute;
        right: 0px;
        padding-right: 20px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}



.content:hover .title {
  color: #3181d1;
  transition: all 0.5s linear;
  cursor: pointer;
}

.el-pagination .el-select .el-input .el-input__inner {
  padding-right: 10px;
}

.el-input__suffix {
  display: none;
}

.citylist {
  display: none;
}

@media screen and (max-width: 768px) {
  .icon {
    width: 6% !important;
  }

  .container .imageCover {
    // width: 100%;
    // padding: 20px;
    margin-top: 50px;
    margin-left: 20px;
    height: 250px;
    width: 340px;
    background-size: 100% 100%;
    // background-color: pink;
    background-image: url('../../assets/image/zuzhijiegou.png');
    background-repeat: no-repeat;
    position: relative;

    >p {
      height: 100px;
      width: 11px;
      // border: 1px solid black;
      box-sizing: border-box;
      position: absolute;
      top: 120px;

      &:hover {
        cursor: pointer;
      }
    }

    >p:nth-of-type(1) {
      left: 119px;
    }

    >p:nth-of-type(2) {
      left: 132px;
    }

    >p:nth-of-type(3) {
      left: 145px;
    }

    >p:nth-of-type(4) {
      left: 159px;
    }

    >p:nth-of-type(5) {
      left: 172px;
    }

    >p:nth-of-type(6) {
      left: 186px;
    }

    >p:nth-of-type(7) {
      left: 199px;
    }

    >p:nth-of-type(8) {
      left: 213px;
    }

    >p:nth-of-type(9) {
      left: 226px;
    }

    >p:nth-of-type(10) {
      left: 244px;
    }

    >p:nth-of-type(11) {
      left: 263px;
    }

    >p:nth-of-type(12) {
      left: 277px;
    }

    >p:nth-of-type(13) {
      height: 125px;
      left: 290px;
    }

    >p:nth-of-type(14) {
      height: 125px;
      left: 305px;
    }
  }

  .citylist {
    display: block;
    flex-wrap: wrap;
    display: flex;
    padding: 10px 10px 0 10px;

    .citybox {
      border: 1px solid #0b7dda;
      box-sizing: border-box;
      text-align: center;
      line-height: 30px;
      font-size: 14px;

      &:nth-child(n + 2) {
        border-left: none;
      }

      &.active {
        background: #0b7dda;
        color: white;
      }
    }
  }

  .container {
    min-height: 0;
  }

  .left {
    display: none;
  }

  .right {
    width: 100%;
    margin-left: 0;
  }

  .introduce_content {
    padding: 10px 20px !important;
  }
}

.navTitle {
  font-size: v-bind(fontSize);
}

::v-deep {
  .el-menu-item.is-active {
    color: #409eff !important;
    background-color: #ecf5ff !important;
  }

  .container .el-menu-item:hover {
    background-color: #ecf5ff !important;
    color: #409eff !important;
  }

  .container .el-submenu__title:hover {
    background-color: #ecf5ff !important;
    color: #409eff !important;
  }

  .parent-item,
  .el-submenu__title {
    border: 1px solid #f0f0f0;
    height: 50px !important;
    margin-top: 20px;
    font-size: 15px;
    line-height: 45px;
  }

  .children-item {
    line-height: 40px !important;
    padding: 0 0px !important;
    min-width: 150px !important;
    height: 50px !important;
    border: 1px solid #f0f0f0;
    padding: 0 20px !important
  }

  .parent-menu {
    padding: 10px 20px 30px;
  }

  .is-opened {
    .children-item {
      background-color: #ecf5ff !important;
      border: 1px solid #ecf5ff !important
    }
  }
}
</style>